<template>
	<div class="flex flex-col justify-start">
		<div
			class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex justify-between items-center gap-x-6"
		>
			<div class="flex justify-start items-center gap-x-6">
				<!-- create new offer button -->
				<ui-button
					class="flex items-center flex-shrink-0"
					v-on:click="
						$bus.$emit('toggle-iframe-modal', $route('offers.create'))
					"
				>
					<ui-icon
						class="mr-2 -ml-1 flex-shrink-0 h-5 w-5 text-white"
						name="plus"
						stroke-width="2"
					/>
					<span class="">{{ __("New Offer") }}</span>
				</ui-button>

				<!-- info text -->
				<p class="text-gray-500">
					{{
						__(
							"List now simply and free of charge. The listings can be managed here."
						)
					}}
				</p>
			</div>

			<!-- legend -->
			<div>
				<div class="flex gap-x-4">
					<div class="whitespace-nowrap">
						<div
							class="inline-block align-text-bottom bg-orange-500 w-5 h-5 mr-1"
						></div>
						{{ __("Buy Offers") }}
					</div>
					<div class="whitespace-nowrap">
						<div
							class="inline-block align-text-bottom bg-green-500 rounded-full w-5 h-5 mr-1"
						></div>
						{{ __("Sell Offers") }}
					</div>
				</div>
				<div class="mt-2">
					<div
						class="inline-block align-text-bottom bg-white border-2 border-orange-500 w-5 h-5 mr-1"
					>
						<div
							class="inline-block align-text-bottom bg-orange-500 w-2 h-2 m-1 mb-3"
						></div>
					</div>
					{{ __("Nachfragen nur für Preisticker") }}
				</div>
			</div>
		</div>

		<div class="min-w-full flex-grow pb-36 overflow-x-auto bg-gray-100">
			<!-- overflow-hidden -->

			<table
				class="min-w-full NOTmin-w-256 divide-y divide-gray-300 border-b border-gray-200"
			>
				<thead class="bg-gray-100">
					<tr>
						<!-- <th scope="col"
                            class="pl-6 pr-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        </th> -->
						<th
							scope="col"
							colspan="2"
							class="pl-6 pr-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
						>
							{{ __("Goods/Harvest") }}
						</th>
						<th
							scope="col"
							class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
						>
							{{ __("Fulfilment Date") }}
						</th>
						<th
							scope="col"
							class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
						>
							{{ __("Location") }}
						</th>
						<th
							scope="col"
							class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
						>
							{{ __("Max Distance") }}
						</th>
						<th
							scope="col"
							class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
						>
							{{ __("Quantity") }} in t
						</th>
						<th
							scope="col"
							class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
						>
							{{ __("Price") }}
						</th>
						<th
							scope="col"
							class="py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							:class="showPriceIndication ? 'pl-2 pr-6' : 'px-2'"
						>
							{{ __("Price") }} / {{ __("Basis") }}
						</th>
						<!--
                        <th scope="col"
                            class="max-w-[2rem] px-2 pr-0 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            v-if="showPriceIndication">
                            <div class="">Sofort&#173;kauf?</div>
                        </th>
                        -->
						<th
							scope="col"
							class="pl-2 pr-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
							v-if="showPriceIndication"
						>
							Heute im<br />Preisticker?
						</th>
					</tr>
				</thead>
				<tbody class="bg-gray-50 divide-y divide-gray-300">
					<my-lots-edit-offer
						v-for="(offer, idx) in form.offers"
						:key="'OFFER_' + idx"
						:offer="offer"
						:show-price-indication="showPriceIndication"
						:price-indication-stat="priceIndicationStats[offer.id]"
						:active-futures="activeFutures"
						:inactive-futures="inactiveFutures"
						:idx="idx"
						:form="form"
						:auctionMyLotsState="auctionMyLotsState"
					/>
				</tbody>
			</table>

			<div class="relative">
				<div class="absolute right-0 pr-4 text-right">
					<div class="my-4">
						<label class="block font-medium text-gray-700"
							>{{ __("Alle auswählen") }}
							<input
								type="checkbox"
								id="togglePiCb"
								ref="togglePiCb"
								class="ml-3 mt--1 h-5 w-5 border-gray-300 hover:border-gray-500 rounded text-orange-500 focus:ring-orange-500 cursor-pointer"
								v-on:click="togglePiCheckboxes()"
							/>
						</label>
					</div>
					<!-- save button -->
					<ui-button
						class="flex-shrink-0 ml-auto"
						label="Save"
						v-on:click="submit()"
					>
					</ui-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		filteredOffers: {
			type: Array,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		inactiveFutures: {
			type: Array,
			required: true,
		},
		priceIndicationStats: {
			type: Object,
		},
		auctionMyLotsState: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			form: Vue.observable(
				this.$inertia.form({
					offers: this.filteredOffers.map(function (offer) {
						offer._priceindication_needs_update = false;
						offer._priceindication_active =
							offer.priceindication?.enabled &&
							offer.priceindication?.status != null
								? true
								: false;
						return offer;
					}),
				})
			),
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {
		submit() {
			let that = this;
			this.form.submit("patch", this.$page.url, {
				onSuccess() {
					alert(__("Your offers were updated!"));
					that.$inertia.visit(that.$route("offer_all.bulkEdit"));
				},
				onError() {
					alert(
						__(
							"Your input could not be saved! Please check the error messages below"
						)
					);
				},
			});
		},
		togglePiCheckboxes() {
			let that = this;
			let checkboxes = this.$el.querySelectorAll(".pi-cb");
			checkboxes.forEach((element) => {
				if (that.$refs.togglePiCb.checked == true) {
					element.checked = true;
				} else {
					element.checked = false;
				}
				element.dispatchEvent(new Event("change"));
			});
		},
	},
	computed: {
		showPriceIndication() {
			return this.acl.can_priceindications_edit;
		},
	},
};
</script>
